import React from 'react'

const InsideBanner = () => {
    const style = {
        position: 'relative',
        zIndex: '-1',
        background: 'transparent url(../new-images/services-banner/get-a-quote.webp) right top no - repeat',
        paddingTop: '160px',
        paddingBottom: '160px',
        textAlign: 'center',
        backgroundPosition: 'center',
        backgroundSize: '100 % 100 %',
    }
    return (
        <>
            <div className="contact-banner" style={style}>
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">

                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default InsideBanner